import axios from 'axios'
import {Toast} from 'mint-ui';
import YunJi from '@/assets/js/YunJi'

const Http = (function() {
  const instance = axios.create({
    baseURL: '//' + globalConfig.yunjimarketingapp + '/yunjimarketingapp/app'
  })
  
  instance.interceptors.response.use((res) => {
    return res.data
  }, (error) => {
    // Toast('网络错误')
    return Promise.reject(error)
  })

  instance.interceptors.request.use((config) => {
    let appCount = YunJi.getUrlParams('appCont')
    let ticket = YunJi.getUrlParams('ticket') || '100'
    if (+appCount === 7 && config.params) {
      config.params.ticket = ticket
    }
    return config
  })

  return instance
})()

/**
 * 获取领取信息数据
 * API文档：http://172.16.0.12/showdoc/index.php?s=/%7F&page_id=5017
 */
export const getItemMark = (params) => Http.get('/itemBusinessMark.json', {params})

